import Vue from 'vue'
import Vuex from 'vuex'

// Category
import category from './category'

import app from './app'
import menu from './menu'
import gallery from './gallery'
import message from './message'
import news from './news'
import shops from './shops'
import maps from './maps'
import breadcrumb from './breadcrumb'
import pages from './pages'
Vue.use(Vuex)


const store = () => new Vuex.Store({
  namespaced: true,
  modules: {
    app,
    category,
    menu,
    gallery,
    news,
    message,
    breadcrumb,
    pages,
    shops,
    maps,
  }
})

export default store
